import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ShiftPaths extends OBase {
  update () {
    let dInputTree = this.getObjectInput('Data');
    let oInputTree = this.getFloatInput('Offset');
    let pOutput = this.outputs['Data'].paramObject;

    let tree = ShiftPath(dInputTree, oInputTree);
    pOutput.value = tree;
  }
}

function ShiftPath (dInputTree, oInputTree) {
  var oList = [];
  for (let i = 0; i < oInputTree.branches.length; i++) {
    for (let j = 0; j < oInputTree.branches[i].length; j++) {
      let val = Math.round(oInputTree.branches[i][j]);
      oList.push(val);
    }
  }

  var newTree = new Geometry.DataTree();
  for (let t = 0; t < oList.length; t++) {
    var offset = oList[t];
    for (let i = 0; i < dInputTree.branches.length; i++) {

      if(dInputTree.branches[i].length == 0){
        let path = dInputTree.paths[i];
        var newIndices = [...path.indices];
        if (newIndices.length > Math.abs(offset)) {
          const offset_abs = Math.abs(offset);
          if (offset < 0) {
            newIndices.splice(path.indices.length - offset_abs, offset_abs);
          }
          if (offset > 0) {
            newIndices.splice(0, offset_abs);
          }
        }

        let newPath = new Geometry.GHPath(newIndices);
        newTree.addEmpty(newPath);
      }

      for (let j = 0; j < dInputTree.branches[i].length; j++) {
        let path = dInputTree.paths[i];
        var newIndices = [...path.indices];
        if (newIndices.length > Math.abs(offset)) {
          const offset_abs = Math.abs(offset);
          if (offset < 0) {
            newIndices.splice(path.indices.length - offset_abs, offset_abs);
          }
          if (offset > 0) {
            newIndices.splice(0, offset_abs);
          }
        }
        let newPath = new Geometry.GHPath(newIndices);
        let inputObj = dInputTree.branches[i][j];

        newTree.add(inputObj, newPath);
      }
    }
  }
  return newTree;
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ShiftPaths.js